import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'

const IframeStyled = styled.iframe`
    min-height: 100vh;
    border-radius: 30px 0 0 30px;
`

const Describe = () => {
  const { currentLanguage } = useTranslation()
  const IFrameRef = useRef(null);
  const sendMessage = (locale) => {
    const pmsg = { m: locale, t: 'language' };
    if (!IFrameRef.current) return;
    IFrameRef.current.contentWindow.postMessage(
      pmsg,
      "*"
    );
  };

  useEffect(() => {
    console.log(currentLanguage);

    sendMessage(currentLanguage.locale);
  }, [currentLanguage])

  const url = `https://mostadvideo.com/ocean/#/`
  // const url = `/expansion/describe/index.html`
  return (
    <>
      <IframeStyled ref={IFrameRef} title="describe" src={url} frameBorder="0" width="100%" height="100%" />
    </>
  )
}

export default Describe